/* esm.sh - applesauce-signers@5.2.0/dist/helpers/encryption */
import{isNIP04Encrypted as e}from"applesauce-core/helpers/encryption";export{e as isNIP04};
//# sourceMappingURL=encryption.mjs.map